import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { FORMAT_ELEMENT_COMMAND, ElementFormatType } from "lexical";

/**
 * Plugin to handle automatic alignment of elements based on data attributes
 * This helps with maintaining text alignment when loading content from HTML
 */
export function AlignmentPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Process alignment when the editor is first loaded
    const processAlignments = () => {
      editor.update(() => {
        const elements = document.querySelectorAll("[data-text-align]");
        elements.forEach((element) => {
          const alignValue = element.getAttribute("data-text-align") as ElementFormatType;
          if (alignValue) {
            // Apply alignment through the Lexical command
            editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, alignValue);
            // Remove the data attribute to prevent duplicate processing
            element.removeAttribute("data-text-align");
          }
        });
      });
    };

    // Run once on mount
    setTimeout(processAlignments, 0);

    return () => {};
  }, [editor]);

  return null;
}
